import { 
    useContext, 
    useState 
} from "react";

import { CheckCircle } from "@mui/icons-material";
import { 
    Autocomplete,
    Box,
    FormControlLabel, 
    MenuItem, 
    TextField 
} from "@mui/material";

import { MuiTelInput } from 'mui-tel-input';

import { validatePhoneNumberLength } from 'libphonenumber-js'

import { countries } from "../../utils/countries";
import { RequestNextApi } from "../../api/Request";
import { ShowNotification } from "../../utils/notification/snackbarUtils";
import { 
    ASSETS_UNDER_MANAGE, 
    employmentArray, 
    EMPLOYMENT_TYPE, 
    FIRM_TYPE, 
    NUMBER_OF_EMPLOYEES, 
    PRIMARY_CLIENT_SEGMENT, 
    SPECIALTY_TYPE, 
    YEARS_IN_BUSINESS 
} from "../AnnualConference/Registration/Dashboard/Employment/model";
import { ProgressContext } from "../Context/progressContext";
import { MembershipJoinContext } from "../Context/membershipJoinContext";
import { StyledCheckbox } from "../StyledCheckbox/StyledCheckbox";

export default function RequiredInfo() {
    const { state: progressContext, update: updateProgress} = useContext(ProgressContext);
    const { state: membershipInfoContext, update: updateMembershipInfo} = useContext(MembershipJoinContext);

    const [curCountry, setCurCountry] = useState(null);
    const [states, setStates] = useState([]);
    const [curState, setCurState] = useState(null);

    const updateEmployment = (e) => {
        if (e.target.value === EMPLOYMENT_TYPE.ADVISOR || e.target.value === EMPLOYMENT_TYPE.CPA || 
            e.target.value === EMPLOYMENT_TYPE.ATTORNEY || e.target.value === EMPLOYMENT_TYPE.FUND_MANAGER || e.target.value === EMPLOYMENT_TYPE.INDUSTRY_LEADER) {
            updateMembershipInfo({
                ...membershipInfoContext,
                profile: {
                    ...membershipInfoContext.profile,
                    [e.target.name]: e.target.value,
                    spouseFirstName: '',
                    spouseLastName: '',
                    spouseEmail: '',
                    conferenceTeam: '',
                }
            });
        } else if (e.target.value === EMPLOYMENT_TYPE.SPOUSE) {
            updateMembershipInfo({
                ...membershipInfoContext,
                profile: {
                    ...membershipInfoContext.profile,
                    [e.target.name]: e.target.value,
                    specialty: '',
                    numberOfEmployees: '',
                    primaryClientSegment: '',
                    firmType: '',
                    assetsUnderManagement: '',
                    yearsInBusiness: '',
                }
            });
        } else {
            updateMembershipInfo({
                ...membershipInfoContext,
                profile: {
                    ...membershipInfoContext.profile,
                    [e.target.name]: e.target.value,
                }
            });
        }
    };

    const handleCountryChange = async (country) => {
        updateProgress({isLoading: true});
        setCurCountry(country);
        updateMembershipInfo({
            ...membershipInfoContext,
            user: {
                ...membershipInfoContext.user,
                shipCountry: country?.label
            }
        });
        const states = await fetchStates(country?.code);
        setStates(states);
        updateProgress({isLoading: false});
    };

    const fetchStates = async (countryCode) => {
        try {
            const result = await RequestNextApi.post('/state', 
              {
                countryCode: countryCode
              }
            );
      
            if (result.data.success) {
                return result.data.states;
            } else {
                ShowNotification.warning('Fetch states failed.');
                return;
            }
        } catch (error) {
            ShowNotification.warning('Fetch states failed.');
            return;
        }
    };

    const handleEmploymentTypeChanage = (e) => {
        if (e.target.value === EMPLOYMENT_TYPE.ADVISOR || e.target.value === EMPLOYMENT_TYPE.CPA || 
            e.target.value === EMPLOYMENT_TYPE.ATTORNEY || e.target.value === EMPLOYMENT_TYPE.FUND_MANAGER || e.target.value === EMPLOYMENT_TYPE.INDUSTRY_LEADER) {
            updateMembershipInfo({
                ...membershipInfoContext,
                profile: {
                    ...membershipInfoContext.profile,
                    spouseFirstName: '',
                    spouseLastName: '',
                    spouseEmail: '',
                    conferenceTeam: ''
                }
            });
        }

        if (e.target.value === EMPLOYMENT_TYPE.SPOUSE) {
            updateMembershipInfo({
                ...membershipInfoContext,
                profile: {
                    ...membershipInfoContext.profile,
                    specialty: '',
                    numberOfEmployees: '',
                    primaryClientSegment: '',
                    firmType: '',
                    assetsUnderManagement: '',
                    yearsInBusiness: '',
                }
            });
        }
    }

    const updateMembershipUserInfo = (e) => {
        updateMembershipInfo({
            ...membershipInfoContext,
            user: {
                ...membershipInfoContext.user,
                [e.target.name]: e.target.value
            },
        })
    }

    return (
        <div className='required-information'>
            <div className='flex space-x-2'>
                <CheckCircle className='text-blue-900' fontSize='large' /> 
                <div className='text-3xl text-blue-900'>Required Information</div>
            </div>
            <div className="mt-8 text-2xl text-secondary-500">
                Contact Information
            </div>
            <div className='my-5 grid grid-cols-1 md:grid-cols-5 gap-4'>
                <TextField
                    label="Prefix"
                    color="third"
                    fullWidth
                    size='small'
                    id="prefix"
                    name="prefix"
                    placeholder=""
                    focused
                    value={membershipInfoContext.user.prefix}
                    onChange={(e) => {
                        updateMembershipUserInfo(e)
                    }}
                />
                <TextField
                    label="First Name"
                    color="third"
                    fullWidth
                    size='small'
                    id="firstName"
                    name="firstName"
                    placeholder=""
                    focused
                    value={membershipInfoContext?.user?.firstName}
                    onChange={(e) => {
                        updateMembershipUserInfo(e)
                    }}
                    required
                />
                <TextField
                    label="M.I."
                    color="third"
                    fullWidth
                    size='small'
                    id="middleName"
                    name="middleName"
                    placeholder=""
                    focused
                    value={membershipInfoContext?.user?.middleName}
                    onChange={(e) => {
                        updateMembershipUserInfo(e)
                    }}
                />
                <TextField
                    label="Last Name"
                    color="third"
                    fullWidth
                    size='small'
                    id="lastName"
                    name="lastName"
                    placeholder=""
                    focused
                    value={membershipInfoContext?.user?.lastName}
                    onChange={(e) => {
                        updateMembershipUserInfo(e)
                    }}
                    required
                />
                <TextField
                    label="Suffix"
                    color="third"
                    fullWidth
                    size='small'
                    id="suffix"
                    name="suffix"
                    placeholder=""
                    focused
                    value={membershipInfoContext?.user?.suffix}
                    onChange={(e) => {
                        updateMembershipUserInfo(e)
                    }}
                />
            </div>
            <div className='my-5 grid grid-cols-1 md:grid-cols-2 gap-4'>
                <TextField
                    label="Nickname"
                    color="third"
                    fullWidth
                    size='small'
                    id="nickName"
                    name="nickName"
                    placeholder=""
                    focused
                    value={membershipInfoContext?.user?.nickName}
                    onChange={(e) => {
                        updateMembershipUserInfo(e)
                    }}
                />
                <TextField
                    label="Spouse's name (optional)"
                    color="third"
                    fullWidth
                    size='small'
                    id="spouse"
                    name="spouse"
                    placeholder=""
                    focused
                    value={membershipInfoContext?.user?.spouse}
                    onChange={(e) => {
                        updateMembershipUserInfo(e)
                    }}
                />
            </div>
            <div className='my-5 grid grid-cols-1 md:grid-cols-2 gap-4'>
                <TextField
                    label="Firm Name"
                    color="third"
                    fullWidth
                    size='small'
                    id="firmName"
                    name="firmName"
                    placeholder=""
                    focused
                    value={membershipInfoContext?.user?.firmName}
                    onChange={(e) => {
                        updateMembershipUserInfo(e)
                    }}
                />
                <MuiTelInput 
                    size='small'
                    defaultCountry="US"
                    label='Phone Number'
                    focused
                    value={membershipInfoContext?.user?.dayPhone} 
                    onChange={(value, info) => {
                        if (validatePhoneNumberLength(value, info.countryCode) === 'TOO_LONG' ) {
                            return;
                        }
                        updateMembershipInfo({
                            ...membershipInfoContext,
                            user: {
                                ...membershipInfoContext.user,
                                dayPhone: value
                            },
                        })
                    }} 
                />
            </div>
            <div className="text-2xl text-secondary-500">
                Shipping Address
            </div>
            <div className='my-5 grid grid-cols-1 md:grid-cols-2 gap-4'>
                <TextField
                    label="Firm Name"
                    color="third"
                    fullWidth
                    size='small'
                    id="shipFirmName"
                    name="shipFirmName"
                    placeholder=""
                    focused
                    value={membershipInfoContext?.user?.shipFirmName}
                    onChange={(e) => {
                        updateMembershipUserInfo(e)
                    }}
                />
                <TextField
                    label="Title"
                    color="third"
                    fullWidth
                    size='small'
                    id="shipTitle"
                    name="shipTitle"
                    placeholder=""
                    focused
                    value={membershipInfoContext?.user?.shipTitle}
                    onChange={(e) => {
                        updateMembershipUserInfo(e)
                    }}
                />
            </div>
            <div className='my-5 grid grid-cols-1 md:grid-cols-2 gap-4'>
                <TextField
                    label="Address"
                    color="third"
                    fullWidth
                    size='small'
                    id="shipAddress"
                    name="shipAddress"
                    placeholder=""
                    focused
                    value={membershipInfoContext?.user?.shipAddress}
                    onChange={(e) => {
                        updateMembershipUserInfo(e)
                    }}
                    required
                />
                <TextField
                    label="Address 2"
                    color="third"
                    fullWidth
                    size='small'
                    id="shipAddress2"
                    name="shipAddress2"
                    placeholder=""
                    focused
                    value={membershipInfoContext?.user?.shipAddress2}
                    onChange={(e) => {
                        updateMembershipUserInfo(e)
                    }}
                />
            </div>
            <div className='my-5 grid grid-cols-1 md:grid-cols-2 gap-4'>
                <TextField
                    label="City"
                    color="third"
                    fullWidth
                    size='small'
                    id="shipCity"
                    name="shipCity"
                    placeholder=""
                    focused
                    value={membershipInfoContext?.user?.shipCity}
                    onChange={(e) => {
                        updateMembershipUserInfo(e)
                    }}
                    required
                />
                <TextField
                    label="Zip/Postal Code"
                    color="third"
                    fullWidth
                    size='small'
                    id="shipZip"
                    name="shipZip"
                    placeholder=""
                    focused
                    value={membershipInfoContext?.user?.shipZip}
                    onChange={(e) => {
                        updateMembershipUserInfo(e)
                    }}
                    required
                />
            </div>
            <div className='my-5 grid grid-cols-1 md:grid-cols-2 gap-4'>
                <Autocomplete
                    id="country-select-demo"
                    value={curCountry}
                    onChange={(event, newValue) => {
                        handleCountryChange(newValue);
                    }}
                    size='small'
                    options={countries}
                    autoHighlight
                    getOptionLabel={(option) => option.label}
                    renderOption={(props, option) => (
                        <Box component="li" sx={{ '& > img': { mr: 2, flexShrink: 0 } }} {...props}>
                            <img
                                loading="lazy"
                                width="20"
                                src={`https://flagcdn.com/w20/${option.code.toLowerCase()}.png`}
                                srcSet={`https://flagcdn.com/w40/${option.code.toLowerCase()}.png 2x`}
                                alt=""
                            />
                            {option.label} ({option.code})
                        </Box>
                    )}
                    renderInput={(params) => (
                        <TextField
                            color="third"
                            {...params}
                            label="Country"
                            inputProps={{
                                ...params.inputProps,
                                autoComplete: 'new-password', // disable autocomplete and autofill
                            }}
                            focused
                            required
                        />
                    )}
                />
                <Autocomplete
                    id="country-select-demo"
                    value={curState}
                    onChange={(event, newValue) => {
                        setCurState(newValue);
                        updateMembershipInfo({
                            ...membershipInfoContext,
                            user: {
                                ...membershipInfoContext.user,
                                shipState: newValue?.code
                            }
                        });
                    }}
                    size='small'
                    options={states}
                    autoHighlight
                    getOptionLabel={(option) => option.label}
                    renderOption={(props, option) => (
                        <Box component="li" sx={{ '& > img': { mr: 2, flexShrink: 0 } }} {...props}>
                            {option.label} ({option.code})
                        </Box>
                    )}
                    renderInput={(params) => (
                        <TextField
                            color="third"
                            {...params}
                            label="State/Province"
                            inputProps={{
                                ...params.inputProps,
                                autoComplete: 'new-password', // disable autocomplete and autofill
                            }}
                            focused
                            required={curCountry?.code === 'US'}
                        />
                    )}
                />
            </div>
            <div className="text-2xl text-secondary-500 mt-8">
                Employment Information
            </div>
            <div className='flex mt-2 pr-6 flex-wrap space-x-5'>
                <FormControlLabel
                    control={
                        <StyledCheckbox 
                            name="firmOwner" 
                            onChange={(e) => {
                                updateMembershipInfo({
                                    ...membershipInfoContext,
                                    profile: {
                                        ...membershipInfoContext.profile,
                                        firmOwner: e.target.checked ? 1 : 0
                                    }
                                });
                            }}
                        />
                    }
                    label="I am a firm owner."
                    className='flex-1'
                />
            </div>
            <div className='grid grid-cols-1 md:grid-cols-2 gap-4 mt-5'>
                <TextField
                    label="Employment" 
                    color="third" 
                    fullWidth 
                    id="employment"
                    name="employment"
                    placeholder=""
                    focused
                    select
                    required
                    size='small'
                    value={membershipInfoContext?.profile?.employment}
                    onChange={updateEmployment}
                >
                    {employmentArray.map((option) => {
                        if (option.value !== EMPLOYMENT_TYPE.CONFERENCE_TEAM &&
                                option.value !== EMPLOYMENT_TYPE.PARTNER &&
                                option.value !== EMPLOYMENT_TYPE.SPOUSE &&
                                option.value !== EMPLOYMENT_TYPE.NON_ADVISOR_STAFF) {
                            return (
                                <MenuItem key={option.value} value={option.value}>
                                    {option.label}
                                </MenuItem>
                            )
                        }
                    })}
                </TextField>
            </div>
            {(membershipInfoContext?.profile.employment === EMPLOYMENT_TYPE.ADVISOR || membershipInfoContext?.profile.employment === EMPLOYMENT_TYPE.CPA || 
                membershipInfoContext?.profile.employment === EMPLOYMENT_TYPE.ATTORNEY || membershipInfoContext?.profile.employment === EMPLOYMENT_TYPE.FUND_MANAGER || membershipInfoContext?.profile.employment === EMPLOYMENT_TYPE.INDUSTRY_LEADER) && (
                <div className='grid grid-cols-1 md:grid-cols-2 gap-x-4 gap-y-5 mt-5'>
                    <TextField 
                        label="Specialty" 
                        color="third" 
                        fullWidth 
                        id="specialty"
                        name="specialty"
                        placeholder=""
                        focused
                        select
                        size='small'
                        value={membershipInfoContext?.profile?.specialty}
                        onChange={(e) => updateEmployment(e)}
                        required
                    >
                        {Object.values(SPECIALTY_TYPE).map((option) => (
                            <MenuItem key={option} value={option}>
                                {option}
                            </MenuItem>
                        ))}
                    </TextField>
                    <TextField 
                        label="Number of employees" 
                        color="third" 
                        fullWidth 
                        id="numberOfEmployees"
                        name="numberOfEmployees"
                        placeholder=""
                        focused
                        select
                        size='small'
                        value={membershipInfoContext?.profile?.numberOfEmployees}
                        onChange={(e) => updateEmployment(e)}
                        required
                    >
                        {Object.values(NUMBER_OF_EMPLOYEES).map((option) => (
                            <MenuItem key={option} value={option}>
                                {option}
                            </MenuItem>
                        ))}
                    </TextField>
                    <TextField 
                        label="Primary client segment" 
                        color="third" 
                        fullWidth 
                        id="primaryClientSegment"
                        name="primaryClientSegment"
                        placeholder=""
                        focused
                        select
                        size='small'
                        value={membershipInfoContext?.profile?.primaryClientSegment}
                        onChange={(e) => updateEmployment(e)}
                        required
                    >
                        {Object.values(PRIMARY_CLIENT_SEGMENT).map((option) => (
                            <MenuItem key={option} value={option}>
                                {option}
                            </MenuItem>
                        ))}
                    </TextField>
                    <TextField 
                        label="Firm Type" 
                        color="third" 
                        fullWidth 
                        id="firmType"
                        name="firmType"
                        placeholder=""
                        focused
                        select
                        size='small'
                        value={membershipInfoContext?.profile?.firmType}
                        onChange={(e) => updateEmployment(e)}
                        required
                    >
                        {Object.values(FIRM_TYPE).map((option) => (
                            <MenuItem key={option} value={option}>
                                {option}
                            </MenuItem>
                        ))}
                    </TextField>
                    <TextField 
                        label="Assets under management" 
                        color="third" 
                        fullWidth 
                        id="assetsUnderManagement"
                        name="assetsUnderManagement"
                        placeholder=""
                        focused
                        select
                        size='small'
                        value={membershipInfoContext?.profile?.assetsUnderManagement}
                        onChange={(e) => updateEmployment(e)}
                        required
                    >
                        {Object.values(ASSETS_UNDER_MANAGE).map((option) => (
                            <MenuItem key={option} value={option}>
                                {option}
                            </MenuItem>
                        ))}
                    </TextField>
                    <TextField 
                        label="Years in financial services industry" 
                        color="third" 
                        fullWidth 
                        id="yearsInBusiness"
                        name="yearsInBusiness"
                        placeholder=""
                        focused
                        select
                        size='small'
                        value={membershipInfoContext?.profile?.yearsInBusiness}
                        onChange={(e) => updateEmployment(e)}
                        required
                    >
                        {Object.values(YEARS_IN_BUSINESS).map((option) => (
                            <MenuItem key={option} value={option}>
                                {option}
                            </MenuItem>
                        ))}
                    </TextField>
                </div>
            )}
            {membershipInfoContext?.profile?.employment === EMPLOYMENT_TYPE.SPOUSE && (
                <div className='grid grid-cols-1 md:grid-cols-3 gap-x-3 gap-y-5 mt-5'>
                    <div className='flex-1'>
                        <TextField 
                            label="Spouse's first name" 
                            color="third" 
                            fullWidth 
                            id="spouseFirstName"
                            name="spouseFirstName"
                            focused
                            size='small'
                            value={membershipInfoContext?.profile?.spouseFirstName}
                            onChange={(e) => updateEmployment(e)}
                            required
                        />
                    </div>
                    <div className='flex-1'>
                        <TextField 
                            label="Spouse's last name" 
                            color="third" 
                            fullWidth 
                            id="spouseLastName"
                            name="spouseLastName"
                            focused
                            size='small'
                            value={membershipInfoContext?.profile?.spouseLastName}
                            onChange={(e) => updateEmployment(e)}
                            required
                        />
                    </div>
                    <div>
                        <TextField 
                            label="Spouse's email" 
                            color="third" 
                            fullWidth 
                            id="spouseEmail"
                            name="spouseEmail"
                            focused
                            size='small'
                            value={membershipInfoContext?.profile?.spouseEmail}
                            onChange={(e) => updateEmployment(e)}
                            required
                        />
                    </div>
                </div>
            )}
        </div>
    )
}
